// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cBVA92SOuNIKIke2 {
  margin: 20px auto;
  width: calc(100vw - 60px);
}
.Z_3sGTjL6bkbNqr0 {
  margin: 20px 0;
}
.cBVA92SOuNIKIke2 {
  padding: 12px;
}
@media (max-width: 768px) {
  .cBVA92SOuNIKIke2 {
    width: calc(100vw - 10px);
    padding: 8px;
    padding-bottom: 200px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 {
    margin-top: 12px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 .ptnNdbl5MfkHb535 {
    padding: 12px 8px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 .ptnNdbl5MfkHb535 .PmNAUejlMvUkx0y1 {
    font-size: 14px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 .ptnNdbl5MfkHb535 .VmlnqW0Mqt0Fr9q2 > div {
    margin-bottom: 4px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 .ptnNdbl5MfkHb535 .dAHfkRdaji46RfTQ {
    margin-top: 8px;
  }
  .cBVA92SOuNIKIke2 .Z_3sGTjL6bkbNqr0 .ptnNdbl5MfkHb535 .dAHfkRdaji46RfTQ li {
    padding: 0 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/complaint/index.modules.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,yBAAA;AACF;AACA;EACI,cAAA;AACJ;AAEA;EACE,aAAA;AAAF;AACE;EAAA;IACE,yBAAA;IACA,YAAA;IACA,qBAAA;EAEF;EALA;IAKI,gBAAA;EAGJ;EARA;IAQM,iBAAA;EAGN;EAAQ;IACE,eAAA;EAEV;EACQ;IAEI,kBAAA;EAAZ;EAjBA;IAuBQ,eAAA;EAHR;EApBA;IA0BU,cAAA;EAHV;AACF","sourcesContent":[".complaintWrapper {\n  margin: 20px auto;\n  width: calc(100vw - 60px)\n}\n.bodyCard {\n    margin: 20px 0;\n}\n\n.complaintWrapper {\n  padding: 12px;\n  @media (max-width: 768px) {\n    width: calc(100vw - 10px);\n    padding: 8px;\n    padding-bottom: 200px;\n    .bodyCard {\n      margin-top: 12px;\n      \n      .ant-list-item {\n        padding: 12px 8px;\n        \n        .ant-list-item-meta {\n          &-title {\n            font-size: 14px;\n          }\n          \n          &-description {\n            > div {\n              margin-bottom: 4px;\n            }\n          }\n        }\n        \n        .ant-list-item-action {\n          margin-top: 8px;\n          \n          li {\n            padding: 0 4px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"complaintWrapper": `cBVA92SOuNIKIke2`,
	"bodyCard": `Z_3sGTjL6bkbNqr0`,
	"ant-list-item": `ptnNdbl5MfkHb535`,
	"ant-list-item-meta-title": `PmNAUejlMvUkx0y1`,
	"ant-list-item-meta-description": `VmlnqW0Mqt0Fr9q2`,
	"ant-list-item-action": `dAHfkRdaji46RfTQ`
};
export default ___CSS_LOADER_EXPORT___;
